import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { UnAuthIntentGraph } from '../presentationalComponents/UnAuthIntentGraph';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isUnauthSchemaFetching:
      state.ContactState.ModalitySectionState.isUnauthSchemaFetching,
    unAuthSignInResult:
      state.ContactState.ModalitySectionState.unAuthSignInResult,
    showUnAuthBranching:
      state.ContactState.ModalitySectionState.unAuthBranchingEnabled &&
      state.ContactState.ModalitySectionState.showUnAuthBranching,
  };
};

export const UnAuthIntentGraphContainer = connect(mapStateToProps)(
  UnAuthIntentGraph
);
